module.exports = __webpack_public_path__ + "img/unlocked-icon.35a7d571.svg";